import { render, staticRenderFns } from "./consumeDetailsList.vue?vue&type=template&id=0d49a5e4&scoped=true&"
import script from "./consumeDetailsList.vue?vue&type=script&lang=js&"
export * from "./consumeDetailsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d49a5e4",
  null
  
)

export default component.exports